import { Component, EventEmitter, inject, Input, Output, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs';
import '@diekeure/dcr-components/dcr-text-field.js';
import '@diekeure/dcr-components/dcr-filled-button.js';
import '@diekeure/dcr-components/dcr-inline-button.js';
import { AbstractControl, FormBuilder, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { PORTAL_ENVIRONMENT_TOKEN, ValidPasswordValidator } from '@campus/public-portal';

interface LoginInterface {
  username: string;
  password: string;
}

export const passwordMatchedValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.root.get('password');
  const passwordCheck = control.root.get('passwordCheck');

  return password && passwordCheck && password.value !== passwordCheck.value ? { noPasswordMatch: true } : null;
};

@Component({
  standalone: false,
  selector: 'polpo-register-form',
  templateUrl: './register-form.component.html',
})
export class RegisterFormComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private validPasswordValidator: ValidPasswordValidator = inject(ValidPasswordValidator);
  private title = inject(Title);

  public portalEnvironment = inject(PORTAL_ENVIRONMENT_TOKEN);

  @Input() error: string;
  @Output() register = new EventEmitter<LoginInterface>();

  ngOnInit() {
    this.title.setTitle('Polpo - Registreren');
  }

  public registerForm = this.formBuilder.group({
    email: new FormControl('', {
      validators: [Validators.required, Validators.email],
    }),
    password: new FormControl('', {
      validators: [Validators.required, Validators.minLength(12), Validators.maxLength(128)],
      asyncValidators: [this.validPasswordValidatorFn()],
    }),
    passwordCheck: new FormControl('', {
      validators: [Validators.required, passwordMatchedValidator],
    }),
  });

  public onSubmit() {
    if (!this.registerForm.valid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    this.register.emit(this.registerForm.value as LoginInterface);
  }

  public getControl(name: string): FormControl {
    return this.registerForm.get(name) as FormControl;
  }

  private validPasswordValidatorFn() {
    return (control: AbstractControl) => this.validPasswordValidator.validate(control).pipe(take(1));
  }
}
